import type { IconSvgObject } from './types';

const CourtLawIcon: IconSvgObject = [
  ["path", { d: "M19.8136 20.3777L21.7569 10.2729C21.9058 9.49849 21.5858 8.7089 20.9398 8.25669L13.1485 2.80278C12.4599 2.32076 11.5434 2.32073 10.8548 2.80269L3.06216 8.25662C2.41599 8.70885 2.09595 9.49861 2.24498 10.2731L4.18947 20.3779C4.37066 21.3195 5.19459 22 6.15344 22H17.8496C18.8085 22 19.6325 21.3194 19.8136 20.3777Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M11.5 14.5004L8.5 17.4999M12.0002 10L16.0005 14.0004L13.5004 16.5005L9.5 12.5002L12.0002 10Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default CourtLawIcon;
